module.exports = __webpack_public_path__ + "static/media/customer.8211554f.svg";